<style>
    .close-tip {
        margin-top: 19px;
        padding: 10px 0;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.20);
        text-align: center;
    }
    @media (min-width: 992px) {
        .close-tip {
            padding: 30px 50px;
        }
    }
    @media (min-width: 1200px) {
        .close-tip {
            padding: 160px 70px;
        }
    }
    .close-tip .msg {
        margin-top: 40px;
        color: #333333;
    }
</style>
<template>
    <div>
        <div class="close-tip">
            <div class="ico">
                <img src="../../assets/images/closeTip.png"/>
            </div>
            <div class="msg">
                <p v-if="examStatus.enable">{{textData}}暂未开放，报名开放时间{{examStatus.begin_datetime | formatDate('yyyy-MM-dd HH:ss')}} 至{{examStatus.end_datetime
                | formatDate('yyyy-MM-dd HH:ss')}}，届时可进行报考操作。</p>
                <p v-if="!examStatus.enable">{{textData}}已暂停，请关注报考通知，以便及时了解最新{{textData}}开放信息。</p>
            </div>
        </div>
        <ata-footer></ata-footer>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                examStatus: false,
                textData: ""
            }
        },
        methods: {
            getData: function () {
                this.examStatus = JSON.parse(this.$route.params.time);
                if (this.$route.params.type == "print") {
                    this.textData = "打印准考证";
                    this.$store.commit('setHeaderState', '4');
                }
                else {
                    this.textData = "成绩查询";
                    this.$store.commit('setHeaderState', '5');
                }
            }
        },
        created: function () {
            this.getData();
        }
    }
</script>

